import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function Pricing() {
  return <section id="pricing" className="py-24 relative overflow-hidden" data-id="element-83">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-[500px] bg-brand-pink/10 blur-[120px] rounded-full pointer-events-none" data-id="element-84"></div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-85">
        <div className="text-center mb-16" data-id="element-86">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-white mb-4" data-id="element-87">
            Elegí tu opción de acceso
          </h2>
          <p className="text-gray-400 text-lg" data-id="element-88">
            Inversión por única vez. Acceso de por vida.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-5xl mx-auto items-center" data-id="element-89">
          {/* Option 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-[#0a0a0a] rounded-3xl p-8 border border-white/10 flex flex-col h-full" data-id="element-90">
            <div className="mb-8" data-id="element-91">
              <h3 className="text-2xl font-bold text-white mb-2" data-id="element-92">
                MEGAPACK DEPILACIÓN TOTAL
              </h3>
              <p className="text-gray-400 text-sm" data-id="element-93">
                El sistema completo para organizar tu negocio desde cero.
              </p>
            </div>

            <div className="mb-8" data-id="element-94">
              <span className="text-5xl font-bold text-white" data-id="element-95">$19.990</span>
              <span className="text-gray-400 ml-2" data-id="element-96">ARS</span>
            </div>

            <ul className="space-y-4 mb-8 flex-1" data-id="element-97">
              {['Los 6 Tomos del Sistema en PDF', 'Bono: 100 Historias listas', 'Bono: Plantillas de Canva', 'Bono: Kit Legal', 'Acceso de por vida y actualizaciones'].map((feature, i) => <li key={i} className="flex items-start gap-3 text-gray-300" data-id="element-98">
                  <Check className="w-5 h-5 text-brand-pink shrink-0 mt-0.5" data-id="element-99" />
                  <span className="text-sm" data-id="element-100">{feature}</span>
                </li>)}
            </ul>

            <a href="https://www.blibliotecadigital.com/checkouts/cn/hWNCWN8KXd9mwpDLJNmXNhmU/es-ar?_r=AQAByF7PZ712g3kA8RFQDLXhnDcQKjtKeKkqo4AvQvmHzCM&cart_link_id=QfaCAJ0E&preview_theme_id=152474878124" target="_blank" rel="noopener noreferrer" className="w-full text-center py-4 px-6 rounded-full border-2 border-brand-pink text-brand-pink font-bold hover:bg-brand-pink hover:text-brand-black transition-colors duration-300" data-id="element-101">
              COMPRAR MEGAPACK
            </a>
          </motion.div>

          {/* Option 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-gradient-to-b from-[#1a1a1a] to-[#0a0a0a] rounded-3xl p-8 border-2 border-brand-pink relative lg:scale-105 shadow-[0_0_40px_rgba(248,200,220,0.15)] flex flex-col h-full" data-id="element-102">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-brand-pink text-brand-black px-4 py-1 rounded-full text-sm font-bold flex items-center gap-1 whitespace-nowrap" data-id="element-103">
              ⭐ MÁS ELEGIDO
            </div>

            <div className="mb-8 mt-2" data-id="element-104">
              <h3 className="text-2xl font-bold text-brand-pink mb-2" data-id="element-105">
                COMBO "DE DEPILADORA A DUEÑA"
              </h3>
              <p className="text-gray-400 text-sm" data-id="element-106">
                Ideal si querés dejar de estar 100% atrás de la camilla y
                empezar a gestionar un equipo.
              </p>
            </div>

            <div className="mb-8" data-id="element-107">
              <span className="text-5xl font-bold text-white" data-id="element-108">$27.990</span>
              <span className="text-gray-400 ml-2" data-id="element-109">ARS</span>
            </div>

            <ul className="space-y-4 mb-8 flex-1" data-id="element-110">
              {['TODO lo incluido en el Megapack', 'Programa Avanzado de Liderazgo', 'Estrategias de Escalamiento', 'Cómo contratar y gestionar equipo', 'Soporte prioritario'].map((feature, i) => <li key={i} className="flex items-start gap-3 text-white" data-id="element-111">
                  <Check className="w-5 h-5 text-brand-pink shrink-0 mt-0.5" data-id="element-112" />
                  <span className="text-sm font-medium" data-id="element-113">{feature}</span>
                </li>)}
            </ul>

            <a href="https://www.blibliotecadigital.com/checkouts/cn/hWNCWNgValruF0tcQqsk2Py6/es-ar?_r=AQAB7JQYxqgWMJjTIJ5hZiVUFyPL4JnC2zJlLGuiK-Yy6OU&cart_link_id=L0NLQDLV&preview_theme_id=152474878124" target="_blank" rel="noopener noreferrer" className="w-full text-center py-4 px-6 rounded-full bg-brand-pink text-brand-black font-bold hover:bg-brand-pink-deep hover:scale-[1.02] transition-all duration-300 shadow-[0_0_20px_rgba(248,200,220,0.4)] inline-block" data-id="element-114">
              COMPRAR COMBO PREMIUM
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}